import PropTypes from 'prop-types'

import { getStars } from '../../BuildingAnalytics/helpers'

const Stars = ({ starsValue, starsTotal = 5 }) => (
  <div className="reputation-management-page__stars">{getStars(starsValue, starsTotal)}</div>
)

Stars.propTypes = {
  starsValue: PropTypes.number,
  starsTotal: PropTypes.number,
}

export default Stars
